import { Component, Input } from '@angular/core';
import { EStatus } from '../../../core/enums/status.enum';

export interface WorkflowStep {
  stepNumber: number;
  role: string;
  rawStatus: string;
  status: 'pending' | 'queried' | 'approved' | 'rejected' | 'recommended';
  comment: string;
  assignedTo: { name: string };
  decisionAt: Date | null;
  createdAt: Date | null;
}

export interface Workflow {
  steps: WorkflowStep[];
  overallStatus: string;
}

@Component({
  selector: 'app-review-workflow',
  templateUrl: './review-workflow.component.html',
})
export class ReviewWorkflowComponent {
  @Input() workflow: Workflow = { steps: [], overallStatus: '' };
  EStatus = EStatus;

  get remainingSteps(): number {
    return this.workflow.steps.filter(s => s.status !== 'approved').length;
  }

  get overallLabel(): string {
    if (this.workflow.overallStatus === EStatus.FINALLY_APPROVED) return 'Fully Approved';
    if (this.workflow.overallStatus === EStatus.FINALLY_REJECTED) return 'Rejected';
    return `${this.remainingSteps} step(s) remaining`;
  }

  stepIcon(status: string): string {
    const map: Record<string, string> = {
      approved: 'check_circle',
      rejected: 'cancel',
      queried: 'help_outline',
      recommended: 'thumb_up',
      pending: 'schedule',
    };
    return map[status] || 'radio_button_unchecked';
  }

  stepColor(status: string): string {
    const map: Record<string, string> = {
      approved: 'text-green-600 bg-green-100',
      rejected: 'text-red-600 bg-red-100',
      queried: 'text-amber-600 bg-amber-100',
      recommended: 'text-blue-600 bg-blue-100',
      pending: 'text-gray-400 bg-gray-100',
    };
    return map[status] || 'text-gray-400 bg-gray-100';
  }

  chipColor(status: string): string {
    const map: Record<string, string> = {
      approved: 'bg-green-100 text-green-700 border-green-200',
      rejected: 'bg-red-100 text-red-700 border-red-200',
      queried: 'bg-amber-100 text-amber-700 border-amber-200',
      recommended: 'bg-blue-100 text-blue-700 border-blue-200',
      pending: 'bg-gray-100 text-gray-600 border-gray-200',
    };
    return map[status] || 'bg-gray-100 text-gray-600 border-gray-200';
  }

  connectorColor(status: string): string {
    return status === 'approved' ? 'bg-green-400' : 'bg-gray-200';
  }
}
